import { BRAND, t } from '@procumi/shared';
import { ErrorBox, Loading } from '../components/StateBox';
import { useAsync } from '../hooks/useAsync';
import { api } from '../lib/api';

/**
 * Linkul „Nu mai vreau acest mail” din mailul de dimineață: oprește mailul dintr-un
 * click, fără logare. Oprirea de două ori răspunde la fel, deci și o reîncărcare e ok.
 */
export function MorningStopScreen({ token }: { token: string }) {
  const { data, error, loading } = useAsync(() => api.stopMorningMail(token), [token]);
  const enter = () => window.location.replace(window.location.pathname);

  return (
    <div className="auth">
      <div className="auth-card">
        <div className="auth-brand">
          <img className="logo" src="/brand/procumi-lockup.svg" alt={BRAND.name} />
          <small>{BRAND.tagline}</small>
        </div>

        <div className="sheet pad" style={{ display: 'grid', gap: 14 }}>
          {loading ? <Loading /> : null}
          {!loading && error ? <ErrorBox error={error} /> : null}
          {!loading && data ? (
            <div>
              <h2>{t('Gata, nu mai primești mailul de dimineață')}</h2>
              <p className="hint" style={{ marginTop: 6 }}>
                {t(
                  'Îl poți porni din nou din Profilul meu. Celelalte mailuri (aprobări, necesar nou, comentarii) vin în continuare.',
                )}
              </p>
            </div>
          ) : null}
          {!loading ? (
            <button className="btn" type="button" onClick={enter}>
              {t('Mergi în {0}', BRAND.name)}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
